export interface Section {
    Type: number; // 0 - text, 1 - image/images, 2 - embed, 3 - video/audio URL, 4 - paywall
    Content?: string;
    // Images array of strings
    Images?: string[];

    StartEditMode: boolean;
    MediaKind?: 'audio'; // UI-only hint for a new empty type-3 section
}

let nextSectionUIKey = 0;
const sectionUIKeys = new WeakMap<object, string>();

// Stable UI keys prevent unaffected section components from remounting after an insertion.
export const getSectionKey = (section: object): string => {
    const existingKey = sectionUIKeys.get(section);
    if (existingKey) {
        return existingKey;
    }

    nextSectionUIKey += 1;
    const key = `content-section-${nextSectionUIKey}`;
    sectionUIKeys.set(section, key);
    return key;
};

// Keep the editor hint non-enumerable so parent updates can never persist it.
export const createAudioSection = (): Section => {
    const section: Section = {
        Type: 3,
        Content: '',
        StartEditMode: true,
    };
    Object.defineProperty(section, 'MediaKind', {
        configurable: true,
        value: 'audio',
    });
    return section;
};
